import styled from "styled-components";

export const Title = styled.h1`
font-size: 6vw;
text-align: center;

span {
    font-weight: 800;
    color: #1476C6;
}

`;

export const Button = styled.button`
background-color: #1476C6;
width: 90%;
height: 60px;
border-radius: 20px;
margin-top: 8%;
color: #fff;
font-weight: 500;
`;